var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H18C18.6566 7.5 19.3068 7.62933 19.9134 7.8806C20.52 8.13188 21.0712 8.50017 21.5355 8.96447C21.9998 9.42876 22.3681 9.97996 22.6194 10.5866C22.8707 11.1932 23 11.8434 23 12.5C23 13.1566 22.8707 13.8068 22.6194 14.4134C22.3681 15.02 21.9998 15.5712 21.5355 16.0355C21.0712 16.4998 20.52 16.8681 19.9134 17.1194C19.3068 17.3707 18.6566 17.5 18 17.5H15M9 17.5H6C5.34339 17.5 4.69321 17.3707 4.08658 17.1194C3.47995 16.8681 2.92876 16.4998 2.46447 16.0355C1.52678 15.0979 1 13.8261 1 12.5C1 11.1739 1.52678 9.90215 2.46447 8.96447C3.40215 8.02678 4.67392 7.5 6 7.5H9",
    stroke: "#454545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5H16",
    stroke: "#454545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.604481c544c93793fca9fa6d56b736ca.svg";
export { ForwardRef as ReactComponent };